
import { IEntityMapping } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IPassengerPhonNumberViewModel from '@/components/Passenger/models/IPassengerPhoneNumberViewModel';
import PhoneNumberMapping from '../models/phoneNumber/PhoneNumberMapping';
import PhoneNumberMapper from '@/components/Importer/phoneNumber/PhoneNumberMapper.vue'

@Component({
  components: {
    PhoneNumberMapper,
  },
})
export default class PhoneNumbersMapper extends Vue {
  mappings: Array<IEntityMapping<IPassengerPhonNumberViewModel>> = [];

  @Prop({ required: true }) value: Array<IEntityMapping<IPassengerPhonNumberViewModel>>;

  @Watch('value', { immediate: true }) onValueChanged() {
    this.mappings = this.value;
  }

  handleMappingChanged(mapping: IEntityMapping<IPassengerPhonNumberViewModel>, index: number) {
    this.mappings.splice(index, 1, mapping);
    this.$emit('input', this.mappings);
  }

  addMapping() {
    const firstMapping = this.mappings.find(x => x);
    let configs = null;
    if (firstMapping) {
      // Give the new mapper passenger matching properties from the previous one
      configs = {};
      firstMapping.props.filter(p => PhoneNumberMapping.NON_ENTITY_MAPPINGS.includes(p.propertyName))
        .filter(p => p.propertyName !== PhoneNumberMapping.ENTITY_CREATION_MAPPING)
        .forEach(p => {
          configs[p.propertyName] = JSON.parse(JSON.stringify(p));
        });
    }

    const newMapping = new PhoneNumberMapping(configs);
    this.mappings.push(newMapping);
    this.$emit('input', this.mappings);
  }

  removeMapping(index: number) {
    this.mappings.splice(index, 1);
    this.$emit('input', this.mappings);
  }

}
